export default {
  Pending: 'pending',
  Approved: 'approved',
  Rejected: 'rejected',
};
